var globalSupporterId = null;

var menu = function () {
    $('.burger-open').on('click', function (){
        $('#main-nav').addClass('main-nav--opened');
        $('.menu-overlay').show();
        $('#main-logo').hide();
        $('body').addClass('modal-open mobile-menu-open');
    });

    $('.burger-close').on('click', function (){
        $('.main-nav').removeClass('main-nav--opened');
        $('.menu-overlay').hide();
        $('#main-logo').show();
        $('body').removeClass('modal-open mobile-menu-open');
    });

    // Main Desktop links
    $('.main-nav__link--primary').on('click', function() {
        $('.main-nav__link--primary.active').removeClass('active');
        if (window.matchMedia("(min-width: 1024px)").matches) {
            $('.main-nav--opened').removeClass('main-nav--opened');
        }
        $(this).addClass('active');

        var el = $(this).parent();
        el.find('.main-nav--submenu').addClass('main-nav--opened');
    });

    // Close menu on non menu click
    $('html').on('click', function(e) {
        if (window.matchMedia("(min-width: 1024px)").matches) {
            var subnav = $('.main-nav--opened');

            if (!subnav.parent().has(e.target).length) {
                $('.main-nav__link--primary.active').removeClass('active');
                subnav.removeClass('main-nav--opened');
            }
        }
    });

    // Mobile menu main links
    $('.main-nav__link--first', '.main-nav--submenu').on('click', function() {
        var el = $(this).parents('ul');
        el.find('.main-nav--submenu').removeClass('main-nav--opened');
    });

    $('.submenu-close').on('click', function() {
        var el = $(this).parents('ul');
        el.find('.main-nav--submenu').removeClass('main-nav--opened');
    });

    // if the login menu is present on the nav (non-portal pages)
    // check for the login form
    var loginButton = $('#non-portal-login'),
        loginForm = $('.btMyWorldVision .login form');
    if (loginButton.length && loginForm.length) {
        loginButton.on('click', function(e) {
            e.preventDefault();
            loginForm[0].scrollIntoView({
                behavior: "smooth",
            });
        })
    }
}

var historicalChildModal = {
    modalId: '#childHistoricalModal',
    defaultText: '<span class="child_name">child_name</span>’s profile is no longer available, however, you will find all the photos and videos of <span class="child_gender_himher">child_gender_himher</span> and <span class="child_gender_hisher">child_gender_hisher</span> community on <span class="child_gender_hisher">child_gender_hisher</span> timeline.',
    initialText: null,
    init: function () {
        var $modal = $(historicalChildModal.modalId);

        // Sort out the modal content
        $modal.on('show.bs.modal', function (e) {

            var $target = $(e.relatedTarget),
                givenName = $target.data('given-name'),
                gender = $target.data('gender'),
                source = $target.data('source'),
                himHer = (gender === 'Male') ? 'him' : 'her',
                hisHer = (gender === 'Male') ? 'his' : 'her';

            historicalChildModal.initialText = $modal.find('.message').html();

            // Switch the content if the clicked link is for a profile image
            if (source === 'profile') {
                $modal.find('.message').html(historicalChildModal.defaultText);
            }

            // Swap out the child content
            $('.message .child_name').html(givenName);
            $('.message .child_gender_himher').html(himHer);
            $('.message .child_gender_hisher').html(hisHer);

        });

        // Restore original modal content when we close it
        $modal.on('hide.bs.modal', function () {
            $modal.find('.message').html(historicalChildModal.initialText);
        });
    },
    manualTrigger: function () {
        $('.child-archived').click(function (e) {
            e.preventDefault();

            var $modal = $(historicalChildModal.modalId);
            $modal.modal("show", $( this ));
        });
    }
};

function navScroll () {
    window.onscroll = function(ev) {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const header = document.querySelector('.wvs2-header');
        let lastScrollTop = 0;
        const alerts = document.querySelector('.supporter-alerts--animated');

        if (scrollTop > lastScrollTop && alerts === null) {
            if ((window.pageYOffset) >= 520) {
                header.style.position = 'static';
            } else {
                header.style.position = 'sticky';
            }
        } else {
            header.style.position = 'sticky';
        }

        lastScrollTop = scrollTop;
    };
}

$(document).ready(function () {
    historicalChildModal.init();
    linkJack.init();
    navScroll();

    if ($('.child-selector').length) {
        // fit to size for scrolling area
        function calcDropdownSize() {
            $('.child-select-dropdown-menu').css({height: $('.portrait').height() + 'px'})
        }

        calcDropdownSize();
        $(window).on('resize', function () {
            calcDropdownSize();
        });
    }

    if ($("#disqus_thread").length) {
        (function () {
            var dsq = document.createElement('script');
            dsq.type = 'text/javascript';
            dsq.async = true;
            dsq.src = '//worldvisiondev.disqus.com/embed.js';
            (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(dsq);
        })();
    }

    menu();

    // Create or use existing WV namespace
    var WV = WV || {};

    // Patch indexOf for IE
    var indexOf = function (needle) {

        if (typeof Array.prototype.indexOf === 'function') {
            indexOf = Array.prototype.indexOf;
        } else {
            indexOf = function (needle) {
                var i = -1, index = -1;

                for (i = 0; i < this.length; i++) {
                    if (this[i] === needle) {
                        index = i;
                        break;
                    }
                }

                return index;
            };
        }

        return indexOf.call(this, needle);
    };

    // Navigation adjustments
    (function ($) {
        var toggle = $('#main-nav-toggle button'),
            nav = $('#main-nav'),
            close = nav.find('.close');

        toggle.click(function () {
            //nav.height( $( 'html, body' ).height() );
            nav.show();
        });

        close.click(function () {
            nav.hide();
        });

    })(jQuery);

    // check if we're on child profile or not (need to handle the persisting of child and index a little differently)
    if (window.location.href.indexOf("child_profile") > -1) {
        // do nothing, we handle the events we need to on the timeline.js
    } else {
        // update the nav from local storage
        getFromStorageAndUpdateNavigation();
    }


    // Validation for login and registration
    $('form[role=form]').each(function () {

        var validator = $(this).validate({

            highlight: function (element) {
                $(element).closest('.form-group').addClass('has-error');
            },

            unhighlight: function (element) {
                $(element).closest('.form-group').removeClass('has-error');
                $(element).closest('.form-group').find('.help-block').remove();
            },

            errorElement: 'div',

            errorClass: 'help-block',

            errorPlacement: function (error, element) {
                var insertElement = element;

                if (element.parent('.input-group').length) {
                    insertElement = element.parent();
                }

                if ($(window).width() < 768) {
                    error.insertAfter(insertElement)
                        .css({opacity: 0})
                        .animate({opacity: 1}, 'slow');
                } else {
                    error.insertAfter(insertElement)
                        .css({opacity: 0})
                        .animate({opacity: 1}, 'fast');
                }
            }
        });
    });

    // =================================================================================
    // Decide which submit button should be used when the return ket is pressed
    // =================================================================================

    (function submitSelect() {

        var form = $('form');

        form.on('keypress', function (event) {
            var tgt = $(event.target);

            // Return if element in focus is a textarea
            if (event.target.nodeName === 'TEXTAREA') return;

            // Return if anything but the return key is hit
            if (event.which !== 13) return;

            if (tgt.attr('data-submit-with') !== undefined) {
                var buttonAttr = tgt.attr('data-submit-with');
                form.find('input[data-btn=' + buttonAttr + ']').trigger('click');
            } else if (form.find('input[data-btn=submit-all]').length > 0) {
                form.find('input[data-btn=submit-all]').trigger('click');
            } else {
                form.find('input[type=submit]').trigger('click');
            }

            if ($(event.target).attr('type') !== 'submit') {
                event.preventDefault();
                $(event.target).trigger('click');
            }
        });
    })();

    $('.logout').click(function (e) {
        // if (typeof(Storage) !== "undefined") {
        //     localStorage.clear();
        // }
    });

    backToTimelineKMTracking();

    logoutListener();
    clickLoader.init();
    submitLoader.init();
});

/**
 * Google Analytics Event Tracking
 * @param eventAction
 * @param eventLabel
 */
function s2GaTrackingEvents(eventAction, eventLabel) {
    if (typeof ga != 'undefined') {
        ga('send', {
            hitType: 'event',
            eventCategory: 'Videos',
            eventAction: eventAction,
            eventLabel: eventLabel
        });
    }

    //check if _gaq is set too
    if (typeof _gaq != 'undefined') {
        _gaq.push(['_trackEvent', 'Videos', eventAction, eventLabel]);
    }
}

function add_disqus(modal) {
    $('.disqus_thread').remove();
    var $disqusContainer = $(modal).find('.disqus-container');

    if ($disqusContainer.length > 0) {

        $disqusContainer.html('<div class="disqus_thread" id="disqus_thread"></div>');

        /* * * Disqus Reset Function * * */
        var reset = function (newIdentifier, newUrl, newTitle, newLanguage) {

            //console.log(newIdentifier, newUrl, newTitle, newLanguage);

            DISQUS.reset({
                reload: true,
                config: function () {
                    this.page.identifier = newIdentifier;
                    this.page.url = newUrl;
                    this.page.title = newTitle;
                    this.language = newLanguage;
                }
            });
        };

        var thread = $(modal).find('.disqus-container');
        var thread_identifier = 'WVS2' + $(thread).attr('data-identifier');
        var url = $(thread).attr('data-title');

        reset(thread_identifier, url, thread_identifier, 'en');
    }
}

// update the menu to have links (and text) contextual to the active child
function updateChildNavigation(index, child_name, supporter_id) {
    $('.nav_child_name').html(child_name);

    var profile_url = '/my-sponsorship/timeline/child-profile/' + index;
    var timeline_url = '/my-sponsorship/timeline/' + index;

    $('#main-nav li.childs-profile a').attr('href', profile_url);
    $('#main-nav li.timeline a').attr('href', timeline_url);
    $('#main-nav .navbar-notification').attr('href', notification_url);

    // set the local storage variables now that we've done it
    setLocalStorageSupporterId(supporter_id);
    setLocalStorageChildIndex(supporter_id, index);
    setLocalStorageChildName(supporter_id, child_name);
}

function getFromStorageAndUpdateNavigation() {
    if (getLocalStorageChildIndex() && getLocalStorageChildName() && getLocalStorageSupporterId()) {
        index = getLocalStorageChildIndex();
        child_name = getLocalStorageChildName();
        supporter_id = getLocalStorageSupporterId();

        // updateChildNavigation(index, child_name, supporter_id);
    }
}

function getLocalStorageChildIndex() {
    var supporter_id = getLocalStorageSupporterId();
    if (typeof (Storage) !== "undefined") {
        return localStorage.getItem(supporter_id + '_index');
    } else {
        return false;
    }
}

function setLocalStorageChildIndex(supporter_id, index) {
    if (typeof (Storage) !== "undefined" && typeof (supporter_id) !== "undefined") {
        localStorage.setItem(supporter_id + '_index', index);
    }
}

function getLocalStorageChildName() {
    var supporter_id = getLocalStorageSupporterId();
    if (typeof (Storage) !== "undefined") {
        return localStorage.getItem(supporter_id + '_child_name');
    } else {
        return false;
    }
}

function setLocalStorageChildName(supporter_id, child_name) {
    if (typeof (Storage) !== "undefined" && typeof (supporter_id) !== "undefined") {
        localStorage.setItem(supporter_id + '_child_name', child_name);
    }
}

function getLocalStorageSupporterId() {
    if (typeof (Storage) !== "undefined") {
        return localStorage.getItem('supporter_id');
    } else {
        return false;
    }
}

function setLocalStorageSupporterId(supporter_id) {
    if (getLocalStorageSupporterId() > 0) {

    }
    if (typeof (Storage) !== "undefined" && typeof (supporter_id) !== "undefined") {
        localStorage.setItem('supporter_id', supporter_id);
    }
}

function backToTimelineKMTracking() {
    $('.back-to-timeline-km').click(function (e) {
    });
}

function logoutListener() {

    // listen for a click on the logout item
    $('li.logout a').click(function (e) {

        e.preventDefault();

        // unset the cookie for flash messages
        var name = 'pinnedItemMessage';

        document.cookie = name + '=;Path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT;';

        window.location = $(this).attr('href');

    });
}

/**
 * Update header navigation with new child index
 *
 * @param childIndex
 * @param sponsorshipData
 */
var updateHeaderNavigation = function (childIndex, result) {
    var notificationUrl = '/my-sponsorship/timeline/notifications/' + childIndex + '/',
        timelineUrl = '/my-sponsorship/timeline/' + childIndex + '/',
        $notificationLink = $('#timeline-navbar .navbar-notification');

    // notification updates
    $notificationLink.removeClass('hide');
    var moreButton = $('.supporter-alerts__button', '.supporter-alerts');
    if (moreButton.length) {
        moreButton.attr('href', notificationUrl);
    }
    $('#timeline-navbar li.timeline a').attr('href', timelineUrl);

    fetchNotifications(childIndex);
};

var fetchNotifications = function (childIndex) {
    var echoChildId = WV.results[childIndex].child_profile.echoChildId,
        supporterId = WV.results[childIndex].supporter.echoSupporterId,
        url = CCM_APPLICATION_URL + "/tools" + '/timeline/unread-notifications';

    //Fetch the latest unread count from the DB
    $.getJSON(url, {childId: echoChildId, supporterId: supporterId})
        .done(function (json) {
            var $notificationLink = $('.msp-navigation .notification-count'),   // main nav + mobile
                $profileNotificationLink = $('.navigation-items-container .navigation-items .badge'), // below child profile
                count = json.unreadNotifications;

            // Update or remove counter as needed
            if (count > 0) {
                // $notificationLink.html(count);
                $profileNotificationLink.html(count);
            } else {
                // $notificationLink.remove();
                $profileNotificationLink.remove();
            }
        })
        .fail(function (jqxhr, textStatus, error) {
            // console.log(textStatus + ", " + error);
        });
};

function isMobileSafari() {
    var iosSafari = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    if (iosSafari === false) {
        // The views are checking for null, so returning null to save refactoring them all
        return null;
    }
    return iosSafari;

    // The below was no longer working on iOS10
    //return navigator.userAgent.match(/(iPod|iPhone|iPad)/) && navigator.userAgent.match(/AppleWebKit/)
}

function isMobileSafariOrAndroid() {
    var iosSafari = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream,
        isAndroid = navigator.userAgent.match(/Android/i);

    if (iosSafari === false && isAndroid === null) {
        // The views are checking for null, so returning null to save refactoring them all
        return null;
    }

    return true;
}

function initShare(shareBtns, shareUrl, subject, bodyContent, customContent) {

    if (typeof customContent == 'undefined') {
        customContent = false
    }

    shareBtns.share({
        url: shareUrl,
        linkElem: 'li a',
        text: subject,
        bodyContent: bodyContent,
        customContent: customContent
    });
}

var clickLoader = {
    cta: '.click-loader',
    ctaActiveClass: 'click-loader--has-loader',
    init: function() {
        var self = this,
            $element = $(self.cta);

        $element.click(function() {
            self.btnDisabled();
        });
    },
    btnDisabled: function()
    {
        // Not using $(this) as there may be multiple CTA's on the page
        $(this.cta).addClass(this.ctaActiveClass);
        $(this.cta).attr('disabled', true);
        $(this.cta).attr('aria-disabled', true);
    },
    btnEnabled: function()
    {
        // Not using $(this) as there may be multiple CTA's on the page
        $(this.cta).removeClass(this.ctaActiveClass);
        $(this.cta).attr('disabled', false);
        $(this.cta).attr('aria-disabled', false);
    }
};

var submitLoader = {
    trigger: '#submit-campaign-donation',
    cta: '.donation-component__form__submit',
    ctaActiveClass: 'click-loader click-loader--has-loader',
    init: function() {
        var self = this,
            $element = $(self.trigger);

        $element.submit(function(e) {
            // prevent the form from submitting again
            // for the card preview page we need the button value to be passed which means we can't disable the button itself
            if (!$element.data('submitted')) {
                $element.data('submitted', true);
            } else {
                e.preventDefault();
            }

            self.btnDisabled();
        });
    },
    btnDisabled: function()
    {
        // Not using $(this) as there may be multiple CTA's on the page
        $(this.cta).addClass(this.ctaActiveClass);
        $(this.cta).attr('aria-disabled', true);
    },
    btnEnabled: function()
    {
        // Not using $(this) as there may be multiple CTA's on the page
        $(this.cta).removeClass(this.ctaActiveClass);
        $(this.cta).attr('aria-disabled', false);
    }
};

var linkJack = {
    init: function () {
        var whitelist = [
            '/message_centre/send-card'
        ];
        var modal = $('#light-leave-modal, #modal-link-jack');
        // only work if the modal is present
        if (modal.length && $('#card-link-jack').length === 0) {
            var links = $('header a')
                .add('.nav a') // add nav links
                .add('.breadcrumb a') // add bread crumb nav
                .add('.link-jack') // add any extra defined links
                .add('footer a') // add any extra defined links
                .not('#leave-link-jacked') // exclude the link they will click
                .not('.s2navbar .dropdown-toggle')
                .not('[href*="my-sponsorship/logout"]');

            links.click(function (e) {
                var link =  $(this).attr('href'),
                prevent = true;

                $.each(whitelist, function(idx, val){
                    if (link.indexOf(val) > -1 ) {
                        prevent = false;
                    }
                });

                if (prevent) {
                    e.preventDefault();

                    modal.find('.leave-link-jacked').attr('href', link);
                    modal.modal();
                }
            });
        }
    }
};

/** EOF **/
